import { render, staticRenderFns } from "./aiCustomPageElementConfig.vue?vue&type=template&id=5d05d035&scoped=true&"
import script from "./aiCustomPageElementConfig.vue?vue&type=script&lang=js&"
export * from "./aiCustomPageElementConfig.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPageElementConfig.vue?vue&type=style&index=0&id=5d05d035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05d035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d05d035')) {
      api.createRecord('5d05d035', component.options)
    } else {
      api.reload('5d05d035', component.options)
    }
    module.hot.accept("./aiCustomPageElementConfig.vue?vue&type=template&id=5d05d035&scoped=true&", function () {
      api.rerender('5d05d035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPageElementConfig.vue"
export default component.exports